import request from '../../request';

/** 获取站点信息 GET /apiAdmin/cms/site */
export async function cmsControllerGetSite() {
  return request<any>('/apiAdmin/cms/site', { method: 'GET' });
}

/** 更新站点信息 PUT /apiAdmin/cms/site */
export async function cmsControllerUpdateSite(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/site', { method: 'PUT', data: body });
}

/** Banner 列表 GET /apiAdmin/cms/banners */
export async function cmsControllerGetBanners() {
  return request<any>('/apiAdmin/cms/banners', { method: 'GET' });
}

/** 创建 Banner POST /apiAdmin/cms/banners */
export async function cmsControllerCreateBanner(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/banners', { method: 'POST', data: body });
}

/** 更新 Banner PUT /apiAdmin/cms/banners/:id */
export async function cmsControllerUpdateBanner(
  params: { id: number },
  body: Record<string, unknown>,
) {
  return request<any>(`/apiAdmin/cms/banners/${params.id}`, { method: 'PUT', data: body });
}

/** 删除 Banner DELETE /apiAdmin/cms/banners/:id */
export async function cmsControllerDeleteBanner(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/banners/${params.id}`, { method: 'DELETE' });
}

/** 导航列表 GET /apiAdmin/cms/nav */
export async function cmsControllerGetNav() {
  return request<any>('/apiAdmin/cms/nav', { method: 'GET' });
}

/** 创建导航 POST /apiAdmin/cms/nav */
export async function cmsControllerCreateNav(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/nav', { method: 'POST', data: body });
}

/** 更新导航 PUT /apiAdmin/cms/nav/:id */
export async function cmsControllerUpdateNav(
  params: { id: number },
  body: Record<string, unknown>,
) {
  return request<any>(`/apiAdmin/cms/nav/${params.id}`, { method: 'PUT', data: body });
}

/** 删除导航 DELETE /apiAdmin/cms/nav/:id */
export async function cmsControllerDeleteNav(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/nav/${params.id}`, { method: 'DELETE' });
}

/** 文章列表 POST /apiAdmin/cms/articles/list */
export async function cmsControllerGetArticles(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/articles/list', { method: 'POST', data: body });
}

/** 文章详情 GET /apiAdmin/cms/articles/:id */
export async function cmsControllerGetArticle(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/articles/${params.id}`, { method: 'GET' });
}

/** 创建文章 POST /apiAdmin/cms/articles */
export async function cmsControllerCreateArticle(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/articles', { method: 'POST', data: body });
}

/** 更新文章 PUT /apiAdmin/cms/articles/:id */
export async function cmsControllerUpdateArticle(
  params: { id: number },
  body: Record<string, unknown>,
) {
  return request<any>(`/apiAdmin/cms/articles/${params.id}`, { method: 'PUT', data: body });
}

/** 删除文章 DELETE /apiAdmin/cms/articles/:id */
export async function cmsControllerDeleteArticle(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/articles/${params.id}`, { method: 'DELETE' });
}

/** 联系表单列表 POST /apiAdmin/cms/contact/list */
export async function cmsControllerGetContacts(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/contact/list', { method: 'POST', data: body });
}

/** 更新留言状态 PUT /apiAdmin/cms/contact/:id/status */
export async function cmsControllerUpdateContactStatus(
  params: { id: number },
  body: Record<string, unknown>,
) {
  return request<any>(`/apiAdmin/cms/contact/${params.id}/status`, { method: 'PUT', data: body });
}

/** 删除留言 DELETE /apiAdmin/cms/contact/:id */
export async function cmsControllerDeleteContact(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/contact/${params.id}`, { method: 'DELETE' });
}

/** 首页区块列表 GET /apiAdmin/cms/sections */
export async function cmsControllerGetSections(params?: { type?: string }) {
  return request<any>('/apiAdmin/cms/sections', { method: 'GET', params });
}

/** 创建首页区块 POST /apiAdmin/cms/sections */
export async function cmsControllerCreateSection(body: Record<string, unknown>) {
  return request<any>('/apiAdmin/cms/sections', { method: 'POST', data: body });
}

/** 更新首页区块 PUT /apiAdmin/cms/sections/:id */
export async function cmsControllerUpdateSection(
  params: { id: number },
  body: Record<string, unknown>,
) {
  return request<any>(`/apiAdmin/cms/sections/${params.id}`, { method: 'PUT', data: body });
}

/** 删除首页区块 DELETE /apiAdmin/cms/sections/:id */
export async function cmsControllerDeleteSection(params: { id: number }) {
  return request<any>(`/apiAdmin/cms/sections/${params.id}`, { method: 'DELETE' });
}
